import { Divider, IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import React from "react";
import styled from "styled-components";
import UserLookupChip from "../userLookup/UserLookupChip";
import FunctionsContext from "./FunctionsContext";
const Container = styled.div`
    width:100%
    padding:20px;
    display:grid;
    grid-template-columns: 40px minmax(50px,200px) minMax(125px,250px) minMax(125px,250px) 44px;
    align-items:center;
    padding-top:30px;
    justify-content:center;
    
`;

const StepCount = styled.div`
  text-align: center;
  color: white;
  border-radius: 50%;
  height: 25px;
  line-height: 25px;
  background: gray;
  width: 57px;
`;

const StepCountContainer = styled.div`
  padding-right: 100px;
`;

const StepLabelContainer = styled.div`
  width: 100%;
  padding-right: 15px;  
  padding-left: 30px;
`;

const User = styled.div``;

const IWPPWorkflowStep = ({
  arrayHelpers,
  index,
  formProps,
  editable,
  isGbu,
}) => {
  const workflowstep = formProps.values.workflowSteps[index];
  const { primary, proxy,  stepLabel } = workflowstep;
  const context = React.useContext(FunctionsContext);
  return (
    <>
      <Container key={index}>
        <StepCountContainer>
          <StepCount style={{  background: index===0 ? "#00bcd4":'gray' }}>
            {index===0 ?  "Primary" : "Proxy"}
          </StepCount>
        </StepCountContainer>
        <StepLabelContainer>{stepLabel}</StepLabelContainer>
        <User>
          {<UserLookupChip user={index===0 ?  primary : proxy} />}
        </User>       
        {index!==0 && <IconButton
          onClick={() => context.confirmDeleteOfIWPPAprroverStep(workflowstep)}
        >
          <DeleteIcon />
        </IconButton>}
      </Container>
      <Divider />
    </>
  );
};

export default IWPPWorkflowStep;
